import { ScreenMessage } from '@features/common';
import NoResultsImage from '@assets/NoResults.svg';
import useNoResultsStyles from './NoResults.styles';
import { SEARCH_CONTAINER_HEIGHT } from '@features/customers';

interface Props {
	searchText: string;
}

const NoResults: React.FC<Props> = ({ searchText }) => {
	const classes = useNoResultsStyles();

	return (
		<ScreenMessage
			fullHeight
			fullWidth
			alt="Hombre cruzando los brazos"
			description={
				<>
					La búsqueda realizada <span className={classes.searchText}>{searchText}</span>{' '}
					no obtuvo ningún resultado
					<br />
					<span className={classes.spanText}>Intenta con otra búsqueda</span>
				</>
			}
			id="customers-no-results"
			image={NoResultsImage}
			imageHeight={427}
			imageWidth={406}
			style={{
				height: 'auto',
				minHeight: `calc(100vh - ${SEARCH_CONTAINER_HEIGHT})`,
				padding: '2rem 1rem',
			}}
			title="No se encontraron resultados"
		/>
	);
};

export default NoResults;
